import { useQuery } from '@tanstack/react-query';
import { datasetApi, getDatasetRequestConfig } from '../api';
import { parseTableMetadata, withDefaultName } from '../types';

export const GET_DATASETS_QUERY_KEYS = [
  '@MDH',
  'getTablesApiV2TableGet',
] as const;

export const useTable = (tableName: string) => {
  return useQuery({
    queryKey: GET_DATASETS_QUERY_KEYS,
    queryFn: () =>
      datasetApi.getDatasetsApiV2DatasetsGet(
        { limit: 1000 },
        getDatasetRequestConfig()
      ),
    select: res =>
      res.data.results
        .map(parseTableMetadata)
        .map(withDefaultName)
        .find(table => table.name === tableName),
  });
};
